import { Text, Spinner, Box } from '@nimbus-ds/components';
import { useTranslation } from 'react-i18next';
import { Domain } from '@tiendanube/common/src/enums';

interface AiLoadingStateProps {
  loadingText?: string;
}

function AiLoadingState({
  loadingText,
}: Readonly<AiLoadingStateProps>): JSX.Element {
  const { t } = useTranslation(Domain.CATALOG);
  const defaultLoadingText =
    loadingText || t('products.detail.seo.aiCategorySuggestions.loadingText');
  return (
    <Box
      paddingX="2"
      paddingY="1-5"
      borderColor="neutral-surfaceHighlight"
      borderWidth="1"
      borderStyle="solid"
      borderRadius="2"
    >
      <Box
        display="flex"
        gap="2"
        alignItems="center"
        justifyContent="flex-start"
      >
        <Spinner size="small" color="neutral-textLow" />
        <Text fontSize="caption" color="neutral-textLow">
          {defaultLoadingText}
        </Text>
      </Box>
    </Box>
  );
}

export default AiLoadingState;
